import {
  CODE_CHECK_STATUSES,
  CODE_EVENT_TYPE,
  SMS_SERVICE_API_HOST,
} from '@src/constants';
import { getCookie } from '@src/utils/cookies';
import axios from 'axios';

const smsService = axios.create({
  baseURL: SMS_SERVICE_API_HOST,
  headers: {
    'Cache-Control': 'no-cache',
    'Content-Type': 'application/json',
  },
});

smsService.interceptors.request.use((config) => {
  const { skipAuth } = config as any;

  if (!skipAuth) {
    const accessToken = getCookie('ACCESS_TOKEN');
    if (accessToken) {
      config.headers.Authorization = `Bearer ${accessToken}`;
    }
  }

  return config;
});
smsService.interceptors.response.use((response) => response.data);

export interface PostSendRegistrationPhoneCodeParams {
  phone: string;
  skipAuth?: boolean;
}

export async function postSendRegistrationPhoneCode({
  phone,
  skipAuth,
}: PostSendRegistrationPhoneCodeParams): Promise<unknown> {
  try {
    const { csrf: csrfToken } = await getCsrfToken();

    return await smsService.request({
      method: 'post',
      url: '/send/send_code/v2/registration',
      // @ts-expect-error
      skipAuth,
      headers: {
        'X-CSRF': csrfToken,
      },
      data: {
        phone,
        eventCode: CODE_EVENT_TYPE.DEFAULT,
      },
    });
  } catch (error: any) {
    const data = error && error.response && error.response.data;

    const isOnlyErrorKey =
      data &&
      typeof data === 'object' &&
      Object.keys(data).length === 1 &&
      Object.prototype.hasOwnProperty.call(data, 'error');

    if (isOnlyErrorKey) {
      throw new Error(data.error);
    }

    const fallbackErrorMessage = JSON.stringify(
      {
        status: error && error.response && error.response.status,
        statusText: error && error.response && error.response.statusText,
        data,
        message: error && error.message,
      },
      null,
      2
    );

    throw new Error(fallbackErrorMessage);
  }
}

export async function postSendAuthorizationPhoneCode({
  phone,
  skipAuth,
}: PostSendRegistrationPhoneCodeParams): Promise<unknown> {
  try {
    // const { csrf: csrfToken } = await getCsrfToken();

    return await smsService.request({
      method: 'post',
      url: '/send/send_code/authorization',
      // @ts-expect-error
      skipAuth,
      // headers: {
      //   'X-CSRF': csrfToken,
      // },
      data: {
        phone,
        eventCode: CODE_EVENT_TYPE.DEFAULT,
      },
    });
  } catch (error: any) {
    const data = error && error.response && error.response.data;

    const isOnlyErrorKey =
      data &&
      typeof data === 'object' &&
      Object.keys(data).length === 1 &&
      Object.prototype.hasOwnProperty.call(data, 'error');

    if (isOnlyErrorKey) {
      throw new Error(data.error);
    }

    const fallbackErrorMessage = JSON.stringify(
      {
        status: error && error.response && error.response.status,
        statusText: error && error.response && error.response.statusText,
        data,
        message: error && error.message,
      },
      null,
      2
    );

    throw new Error(fallbackErrorMessage);
  }
}

interface GetCsrfToken {
  csrf: string;
}

export function getCsrfToken(): Promise<GetCsrfToken> {
  return smsService.request({
    method: 'get',
    url: `/csrf?_t=${Date.now()}`,
    // @ts-expect-error
    skipAuth: true,
  });
}

export interface PostCheckCodeParams {
  phone: string;
  code: string;
  skipAuth?: boolean;
}

export function postCheckPhoneCode(
  data: PostCheckCodeParams
): Promise<{ status: CODE_CHECK_STATUSES }> {
  const { skipAuth, ...rest } = data;

  return smsService.request({
    method: 'post',
    url: '/send/check_code',
    // @ts-expect-error
    skipAuth,
    data: rest,
  });
}

export function getUrl(urlId: string): Promise<{ url: string }> {
  return smsService.request({
    url: '/url',
    params: {
      urlId,
    },
  });
}
